import { Button, Typography } from "@mui/material"
import SectionTitle from "../../components/section-title/SectionTitle"
import { Link } from "react-router-dom"
import { faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function Error404(_props) {
  const {
    title = "Recurso no encontrado",
    message = "El recurso que estás buscando no existe.",
    actionLabel = "Volver al inicio",
    actionRoute = "/",
  } = _props
  
  const titleWithWarning = (
    <span className="text-error"><FontAwesomeIcon icon={faWarning} size={'1x'} />&nbsp;{title}</span>
  )
  
  
  return (
    <div className="py-20">
    <SectionTitle title={titleWithWarning} className="mb-8" />
    <Typography variant="h3" component="p" className="mb-8">
        
        {message}
    </Typography>
    <Button component={Link} to={actionRoute} variant="contained" color="primary">
      {actionLabel}
    </Button>
    </div>
  )

}

export default Error404